import { svg } from 'lit';

export const bookmarkIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M7,22.1c-0.3,0-0.5-0.2-0.5-0.5V6.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v14.8C7.5,21.9,7.3,22.1,7,22.1z"/>
	<path d="M13.4,11.9c-0.3,0-0.5-0.2-0.5-0.5V2.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v9.3C13.9,11.7,13.7,11.9,13.4,11.9z"/>
	<path d="M7,22.1c-0.1,0-0.2,0-0.3-0.1l-6.5-4.7C0.1,17.2,0,17.1,0,16.9V2.1c0-0.2,0.1-0.3,0.3-0.4s0.4-0.1,0.5,0L7,6.2l6.2-4.5
		c0.2-0.1,0.4-0.1,0.6,0l6.5,4.7c0.1,0.1,0.2,0.2,0.2,0.4v4.7c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5V7l-6-4.3L7.3,7.2
		c-0.2,0.1-0.4,0.1-0.6,0L0.9,3.1v13.6l6,4.3l5.3-3.8c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7l-5.6,4
		C7.2,22.1,7.1,22.1,7,22.1z"/>
	<g>
		<path d="M15.8,19.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c0.8,0,1.5,0.4,1.9,1.1l-0.9,0.5c-0.2-0.4-0.6-0.6-1-0.6
			c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.4,0,0.8-0.2,1-0.6l0.9,0.4C17.3,19,16.6,19.4,15.8,19.4z"/>
		<path d="M21.8,16.4v-1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1c0,0.2,0,0.3,0.1,0.5L20,15.3
			c-0.1-0.3-0.2-0.6-0.2-0.9c0-1.1,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S23,16.4,21.8,16.4z"/>
		<path d="M21.8,22.4c-0.7,0-1.4-0.4-1.8-1c-0.4-0.6-0.4-1.4-0.1-2l0.9,0.4c-0.2,0.3-0.2,0.8,0,1.1c0.2,0.3,0.6,0.5,0.9,0.5
			c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1v-1c1.1,0,2.1,0.9,2.1,2.1C23.9,21.5,23,22.4,21.8,22.4z"/>
		<path d="M20.4,20.1c-0.1,0-0.1,0-0.2-0.1l-3.1-1.6c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0-0.3,0-0.4c0.1-0.2,0.1-0.3,0.1-0.5
			c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.1-0.2,0-0.4c0-0.1,0.1-0.2,0.2-0.3l3.1-1.6c0.2-0.1,0.5,0,0.6,0.2c0.2,0.4,0.6,0.6,1,0.6v1
			c-0.6,0-1.2-0.3-1.6-0.7l-2.3,1.3c0,0.2,0.1,0.3,0.1,0.5c0,0.2,0,0.3-0.1,0.5l2.4,1.2c0.4-0.5,1-0.7,1.6-0.7v1
			c-0.4,0-0.8,0.2-1,0.6C20.7,20,20.6,20.1,20.4,20.1z"/>
	</g>
</svg>`;

export const drawIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M0.3,24c-0.1,0-0.2,0-0.3-0.1s-0.2-0.3-0.1-0.4l1.5-6.6c0-0.1,0.1-0.2,0.1-0.2l15.9-16c1-1,2.6-0.9,3.6,0l2.2,2.2
		c1,1,1,2.6,0,3.6l-16,15.8c-0.1,0.1-0.1,0.1-0.2,0.1l-6.6,1.5C0.4,24,0.4,24,0.3,24z M2.3,17.2L1,22.9l5.7-1.4L22.5,5.7
		c0.6-0.6,0.6-1.6,0-2.2l-2.2-2.2c-0.6-0.6-1.6-0.6-2.2,0L2.3,17.2z M6.9,22L6.9,22L6.9,22z"/>
	<path class="st0" d="M15.6,3.2"/>
	<path class="st0" d="M20.7,8.2"/>
	<path d="M7.2,22.2c-0.1,0-0.2,0-0.3-0.1l-5-5c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l5,5c0.2,0.2,0.2,0.5,0,0.7
		C7.4,22.1,7.3,22.2,7.2,22.2z"/>
</svg>`;

export const informationIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M17.1,24H6.9c-0.3,0-0.5-0.2-0.5-0.5S6.6,23,6.9,23h10.2c0.3,0,0.5,0.2,0.5,0.5S17.4,24,17.1,24z"/>
	<path d="M12,23.7c-0.3,0-0.5-0.2-0.5-0.5V8.6H8.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H12c0.3,0,0.5,0.2,0.5,0.5v15.1
		C12.5,23.5,12.3,23.7,12,23.7z"/>
	<g>
		<path d="M11.1,2.6c-0.7,0-1.3-0.6-1.3-1.3S10.4,0,11.1,0c0.7,0,1.3,0.6,1.3,1.3C12.5,2,11.9,2.6,11.1,2.6z M11.1,0.9
			c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4S11.4,0.9,11.1,0.9z"/>
	</g>
</svg>`;

export const informationCircleIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M14.6,17.4h-2.1V10c0-0.3-0.2-0.5-0.5-0.5h-1.7C10,9.5,9.7,9.7,9.7,10s0.2,0.5,0.5,0.5h1.2v6.9H9.4c-0.3,0-0.5,0.2-0.5,0.5
		s0.2,0.5,0.5,0.5h5.2c0.3,0,0.5-0.2,0.5-0.5S14.9,17.4,14.6,17.4z"/>
	<path d="M11.5,7.4c0.3,0,0.6-0.1,0.7-0.3c0.2-0.2,0.2-0.4,0.2-0.6c0-0.5-0.4-0.9-0.9-0.9S10.6,6,10.6,6.5S11,7.4,11.5,7.4z
		 M11.5,6.5C11.6,6.5,11.6,6.5,11.5,6.5C11.6,6.5,11.6,6.6,11.5,6.5C11.5,6.5,11.5,6.5,11.5,6.5C11.5,6.5,11.5,6.5,11.5,6.5z"/>
	<path d="M12,0C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12C24,5.4,18.6,0,12,0z M12,23.1c-6.1,0-11.1-5-11.1-11.1
		c0-6.1,5-11.1,11.1-11.1c6.1,0,11.1,5,11.1,11.1C23.1,18.1,18.1,23.1,12,23.1z"/>
</svg>`;

export const isochroonIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M12,24C6.5,24,2,19.5,2,14S6.5,4,12,4s10,4.5,10,10S17.5,24,12,24z M12,5c-5,0-9,4-9,9s4.1,9,9,9s9-4.1,9-9S17,5,12,5z"/>
	<path d="M15,1H9C8.7,1,8.5,0.7,8.5,0.5S8.7,0,9,0h6c0.3,0,0.5,0.2,0.5,0.5S15.3,1,15,1z"/>
	<path d="M18.7,7.8c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l1.8-1.8c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-1.8,1.8
		C19,7.7,18.9,7.8,18.7,7.8z"/>
	<path d="M13.5,5C13.2,5,13,4.8,13,4.5V1h-2v3.6C11,4.8,10.8,5,10.5,5S10,4.8,10,4.5v-4C10,0.2,10.2,0,10.5,0h3
		C13.8,0,14,0.2,14,0.5v4.1C14,4.8,13.8,5,13.5,5z"/>
	<path d="M21,6.5c-0.1,0-0.2,0-0.3-0.1l-1-1c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l1,1c0.2,0.2,0.2,0.5,0,0.7
		C21.3,6.4,21.1,6.5,21,6.5z"/>
	<path d="M12,14.5c-0.1,0-0.2,0-0.3-0.1L7.2,9.8C7,9.6,7,9.3,7.2,9.2s0.5-0.2,0.7,0l4.5,4.5c0.2,0.2,0.2,0.5,0,0.7
		C12.2,14.4,12.1,14.5,12,14.5z"/>
</svg>`;

export const layermanagerIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M12,16c-0.1,0-0.1,0-0.2,0L0.3,11C0,10.8-0.1,10.5,0,10.3s0.4-0.4,0.6-0.2L12,14.9L23.3,10c0.2-0.1,0.5,0,0.6,0.2
		s0,0.5-0.2,0.6l-11.5,5C12.1,15.9,12.1,16,12,16z"/>
	<path d="M12,19c-0.1,0-0.1,0-0.2,0L0.3,14C0,13.8-0.1,13.5,0,13.3s0.4-0.4,0.6-0.2L12,18l11.3-4.9c0.2-0.1,0.5,0,0.6,0.2
		s0,0.5-0.2,0.6l-11.5,5C12.1,18.9,12.1,19,12,19z"/>
	<path d="M12,22c-0.1,0-0.1,0-0.2,0L0.3,17C0,16.8-0.1,16.5,0,16.3c0.1-0.2,0.4-0.4,0.6-0.2L12,21l11.3-4.9c0.2-0.1,0.5,0,0.6,0.2
		c0.1,0.2,0,0.5-0.2,0.6l-11.5,5C12.1,21.9,12.1,22,12,22z"/>
	<path d="M12,12.9c-0.1,0-0.1,0-0.2,0l-11.5-5C0.1,7.8,0,7.6,0,7.5s0.1-0.4,0.3-0.4l11.5-5c0.1-0.1,0.3-0.1,0.4,0l11.5,5
		c0.2,0,0.3,0.2,0.3,0.4s-0.1,0.4-0.3,0.4l-11.5,5C12.1,12.9,12.1,12.9,12,12.9z M1.7,7.5L12,11.9l10.3-4.5L12,3L1.7,7.5z"/>
</svg>`;

export const logoutIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M14.7,19.7c-0.3,0-0.5,0.2-0.5,0.5v2.7H1.1V1.1h13.1v3.8c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5V0.5
		C15.3,0.2,15,0,14.7,0H0.5C0.2,0,0,0.2,0,0.5v22.9C0,23.8,0.2,24,0.5,24h14.2c0.3,0,0.5-0.2,0.5-0.5v-3.3
		C15.3,19.9,15,19.7,14.7,19.7z"/>
	<path d="M23.8,12.2l-5.5-5.5c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8l4.5,4.5H4.9c-0.3,0-0.5,0.2-0.5,0.5
		c0,0.3,0.2,0.5,0.5,0.5h17.2l-4.5,4.5c-0.2,0.2-0.2,0.6,0,0.8c0.1,0.1,0.2,0.2,0.4,0.2s0.3-0.1,0.4-0.2l5.4-5.4
		c0.1-0.1,0.2-0.2,0.2-0.4c0,0,0,0,0,0C24,12.4,23.9,12.3,23.8,12.2z"/>
</svg>`;

export const measureIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M6,24c-0.1,0-0.2-0.1-0.3-0.1l-5.5-5.5c-0.2-0.2-0.2-0.5,0-0.7L17.7,0.2c0.2-0.2,0.5-0.2,0.7,0l5.4,5.5
		c0.2,0.2,0.2,0.5,0,0.7L6.3,23.9C6.2,24,6.1,24,6,24z M1.1,18l4.8,4.8L22.9,5.9l-4.8-4.8L1.1,18z"/>
	<path d="M6.5,17.5c-0.1,0-0.2,0-0.3-0.1l-2.5-2.5c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l2.4,2.5c0.2,0.2,0.2,0.5,0,0.7
		C6.7,17.5,6.6,17.5,6.5,17.5z"/>
	<path d="M8,14.9c-0.1,0-0.2,0-0.3-0.1l-2-2c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l2,2c0.2,0.2,0.2,0.5,0,0.7
		C8.2,14.9,8.1,14.9,8,14.9z"/>
	<path d="M10.6,13.2c-0.1,0-0.2,0-0.3-0.1l-2.5-2.5c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l2.5,2.5c0.2,0.2,0.2,0.5,0,0.7
		C10.9,13.1,10.9,13.2,10.6,13.2z"/>
	<path d="M11.9,10.4c-0.1,0-0.2,0-0.3-0.1L9.8,8.5C9.6,8.3,9.6,8,9.8,7.8c0.2-0.2,0.5-0.2,0.7,0l1.8,1.8c0.2,0.2,0.2,0.5,0,0.7
		C12.2,10.4,12.2,10.4,11.9,10.4z"/>
	<path d="M15,8.9c-0.1,0-0.2,0-0.3-0.1l-2.5-2.5c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l2.5,2.5c0.2,0.2,0.2,0.5,0,0.7
		C15.2,8.9,15.2,8.9,15,8.9z"/>
	<path d="M16.6,6.4c-0.1,0-0.2,0-0.3-0.1l-2-2c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l2,2c0.2,0.2,0.2,0.5,0,0.7
		C16.9,6.3,16.6,6.4,16.6,6.4z"/>
		</svg>`;

export const menuIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M0.8,1.5h22.5c0.4,0,0.8-0.3,0.8-0.8S23.7,0,23.2,0H0.8C0.3,0,0,0.3,0,0.8S0.3,1.5,0.8,1.5z"/>
	<path d="M23.2,6.2H0.8C0.3,6.2,0,6.5,0,6.9c0,0.4,0.3,0.8,0.8,0.8h22.5c0.4,0,0.8-0.3,0.8-0.8C24,6.5,23.7,6.2,23.2,6.2z"/>
	<path d="M23.2,12.3H0.8c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h22.5c0.4,0,0.8-0.3,0.8-0.8S23.7,12.3,23.2,12.3z"/>
	<path d="M23.2,18.5H0.8c-0.4,0-0.8,0.3-0.8,0.8S0.3,20,0.8,20h22.5c0.4,0,0.8-0.3,0.8-0.8S23.7,18.5,23.2,18.5z"/>
</svg>`;

export const redistrictIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M22.1,22.9c-0.1,0-0.2,0-0.3-0.1L8.2,10.6c-0.3-0.2-0.3-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7,0l13.6,12.3
		c0.2,0.2,0.2,0.5,0,0.7C22.4,22.8,22.2,22.9,22.1,22.9z"/>
	<path d="M0.5,19.1c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7L11.5,6c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7L0.9,18.9
		C0.8,19,0.6,19.1,0.5,19.1z"/>
	<g>
		<path d="M20.9,23.5H2c-1.1,0-2-1-2-2.2V7.9c0-1.2,1-2.1,2-2.1h11c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5H2
			C1.4,6.7,1,7.3,1,7.9v13.4C1,22,1.4,22.5,2,22.5h18.8c0.6,0,1.1-0.6,1.1-1.2V12c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v9.3
			C22.9,22.6,22.1,23.5,20.9,23.5z"/>
	</g>
	<g>
		<path d="M19.3,13c-0.1,0-0.3,0-0.3-0.1c-0.5-0.5-4.3-5.2-4.3-7.7c0-2.6,2.1-4.7,4.7-4.7c2.5,0,4.6,2.1,4.6,4.7
			c0,2.4-3.8,7.1-4.3,7.7C19.6,13,19.5,13,19.3,13z M19.3,1.4c-2,0-3.7,1.6-3.7,3.7c0,1.6,2.4,4.9,3.7,6.5c1.3-1.5,3.7-4.9,3.7-6.5
			C23,3.2,21.4,1.4,19.3,1.4z"/>
		<path d="M19.3,7.2c-1.1,0-2-0.9-2-2s1-2,2-2c1.1,0,2,1,2,2S20.4,7.2,19.3,7.2z M19.3,4.1c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1
			c0.6,0,1.1-0.5,1.1-1.1S20,4.1,19.3,4.1z"/>
	</g>
</svg>`;

export const  printIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M21.5,18h-3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3c0.8,0,1.5-0.7,1.5-1.5v-6C23,8.7,22.4,8,21.5,8h-19
		C1.6,8,1,8.7,1,9.5v6C1,16.3,1.6,17,2.5,17h3C5.8,17,6,17.2,6,17.5S5.8,18,5.5,18h-3C1.1,18,0,16.9,0,15.5v-6C0,8.1,1.1,7,2.5,7h19
		C22.9,7,24,8.1,24,9.5v6C24,16.9,22.9,18,21.5,18z"/>
	<path d="M18.5,6C18.2,6,18,5.8,18,5.5V4.7L15.3,2H6v3.5C6,5.8,5.8,6,5.5,6S5,5.8,5,5.5v-4C5,1.2,5.2,1,5.5,1h10
		c0.1,0,0.2,0.1,0.3,0.1l3,3c0.1,0.1,0.1,0.2,0.1,0.3v1C19,5.8,18.8,6,18.5,6z"/>
	<path d="M18.5,23h-13C5.2,23,5,22.8,5,22.5v-8C5,14.2,5.2,14,5.5,14h13c0.3,0,0.5,0.2,0.5,0.5v8C19,22.8,18.8,23,18.5,23z M6,22
		h12.1v-7H6V22z"/>
	<path d="M3.5,12C2.7,12,2,11.3,2,10.5S2.7,9,3.5,9S5,9.7,5,10.5S4.3,12,3.5,12z M3.5,10C3.2,10,3,10.2,3,10.5S3.2,11,3.5,11
		S4,10.8,4,10.5S3.8,10,3.5,10z"/>
	<path d="M16.5,17h-9C7.2,17,7,16.8,7,16.5S7.2,16,7.5,16h9c0.3,0,0.5,0.2,0.5,0.5S16.8,17,16.5,17z"/>
	<path d="M16.5,19h-9C7.2,19,7,18.8,7,18.5S7.2,18,7.5,18h9c0.3,0,0.5,0.2,0.5,0.5S16.8,19,16.5,19z"/>
	<path d="M16.5,21h-9C7.2,21,7,20.8,7,20.5S7.2,20,7.5,20h9c0.3,0,0.5,0.2,0.5,0.5S16.8,21,16.5,21z"/>
	<path d="M18.5,5h-3C15.2,5,15,4.8,15,4.5v-3C15,1.2,15.2,1,15.5,1S16,1.2,16,1.5V4h2.5C18.8,4,19,4.2,19,4.5S18.8,5,18.5,5z"/>
</svg>`;

export const routeIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M5.4,13.1c-0.1,0-0.3-0.1-0.4-0.2c-0.4-0.6-4.4-5.5-4.4-8C0.6,2.2,2.8,0,5.5,0s4.9,2.2,4.9,4.9c0,2.5-4,7.4-4.5,8
		C5.7,13,5.6,13.1,5.4,13.1z M5.4,1C3.3,1,1.6,2.7,1.6,4.9c0,1.6,2.5,5.2,3.9,6.9c1.2-1.7,3.8-5.3,3.8-6.9C9.4,2.7,7.6,1,5.4,1z"/>
	<path d="M5.4,7C4.3,7,3.3,6,3.3,4.9s1-2.1,2.1-2.1s2.1,1,2.1,2.1S6.6,7,5.4,7z M5.4,3.7c-0.6,0-1.2,0.5-1.2,1.2S4.8,6,5.4,6
		s1.2-0.5,1.2-1.2S6.1,3.7,5.4,3.7z"/>
	<path d="M18.5,24c-0.1,0-0.3-0.1-0.4-0.2c-0.5-0.6-4.5-5.5-4.5-8c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9c0,2.5-4,7.4-4.5,8
		C18.8,24,18.6,24,18.5,24z M18.5,12c-2.1,0-3.9,1.7-3.9,3.9c0,1.6,2.6,5.2,3.9,6.9c1.3-1.7,3.9-5.2,3.9-6.9
		C22.3,13.7,20.6,12,18.5,12z"/>
	<path d="M18.5,18c-1.2,0-2.1-1-2.1-2.1s1-2.1,2.1-2.1s2.1,1,2.1,2.1S19.6,18,18.5,18z M18.5,14.7c-0.7,0-1.2,0.5-1.2,1.2
		c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2C19.6,15.2,19.1,14.7,18.5,14.7z"/>
	<path d="M6.5,24h-1C5.2,24,5,23.8,5,23.5v-1c0-0.3,0.2-0.5,0.5-0.5S6,22.3,6,22.6V23h0.5C6.8,23,7,23.2,7,23.5
		C7,23.8,6.7,24,6.5,24z"/>
	<path d="M15.4,24h-1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5C15.9,23.8,15.7,24,15.4,24z"/>
	<path d="M12.4,24h-1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5C12.9,23.8,12.7,24,12.4,24z"/>
	<path d="M9.5,24h-1C8.2,24,8,23.8,8,23.5C8,23.2,8.2,23,8.5,23h1c0.3,0,0.5,0.2,0.5,0.5C9.9,23.8,9.7,24,9.5,24z"/>
	<path d="M5.4,15c-0.3,0-0.5-0.2-0.5-0.5v-1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1C5.9,14.8,5.7,15,5.4,15z"/>
	<path d="M5.4,18c-0.3,0-0.5-0.2-0.5-0.5v-1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1C5.9,17.8,5.7,18,5.4,18z"/>
	<path d="M5.4,21c-0.3,0-0.5-0.2-0.5-0.5v-1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1C5.9,20.7,5.7,21,5.4,21z"/>
</svg>`;

export const timesliderIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M20.6,2.8c</iron-iconset-svg>-2-1.9-4.7-2.9-7.4-2.8c-2.9,0.1-5.6,1.5-7.6,3.7C4,5.6,3.2,7.8,3.1,10.3L1,7.1C0.8,6.8,0.5,6.8,0.2,6.9
		C0,7.1-0.1,7.4,</iron-iconset-svg>0.1,7.6l3.1,4.7c0,0,0,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
		c0,0,0,0,0,0c0,</iron-iconset-svg>0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1,0,0.1-0.1,0.2-0.2l3.6-4.2C7.9,8,7.9,7.7,7.6,7.5
		C7.4,7.3,7.1,7.</iron-iconset-svg>3,6.9,7.5l-2.8,3.2c0-2.4,0.8-4.6,2.3-6.4c1.7-2,4.2-3.2,6.8-3.3c2.5-0.1,4.9,0.8,6.7,2.5c1.9,1.7,2.9,4.1,3,6.6
		c0.2,5.2-3.9,9.</iron-iconset-svg>6-9,9.8c-0.3,0-0.5,0.3-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0c5.8-0.2,10.3-5.1,10-10.9
		C23.9,7.3,22.7,</iron-iconset-svg>4.7,20.6,2.8z"/>
	<path d="M18.8,11.5</iron-iconset-svg>c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5h-4.7V5.2c0-0.3-0.2-0.5-0.5-0.5C13.3,4.7,13,5,13,5.2V11
		c0,0.3,0.2,0.5,0.5,0.5H18.8z"/>
</svg>`;

export const tspIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M5.2,23.8L5.2,23.8c-0.1,0-0.3-0.1-0.4-0.2C4.6,23.4,0,17.8,0,15.1c0-2.9,2.3-5.2,5.2-5.2c2.9,0,5.2,2.3,5.2,5.2
	c0,2.7-4.6,8.3-4.8,8.6C5.5,23.7,5.3,23.8,5.2,23.8z M5.2,10.8c-2.3,0-4.2,1.9-4.2,4.2c0,1.8,2.8,5.7,4.2,7.5
	c1.5-1.8,4.2-5.7,4.2-7.5C9.4,12.7,7.5,10.8,5.2,10.8z"/>
	<path d="M5.2,17.3c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2S6.4,17.3,5.2,17.3z M5.2,13.8c-0.7,0-1.3,0.6-1.3,1.3
		s0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3S5.9,13.8,5.2,13.8z"/>
	<path d="M11.3,10.8L11.3,10.8c-0.1,0-0.3-0.1-0.4-0.2C10.6,10.2,7.3,6.1,7.3,4c0-2.3,1.8-4.1,4.1-4.1c2.3,0,4.1,1.8,4.1,4.1
		c0,2.1-3.3,6.2-3.7,6.6C11.6,10.8,11.5,10.8,11.3,10.8z M11.3,0.9C9.6,0.9,8.2,2.3,8.2,4c0,1.3,2,4.1,3.1,5.6
		c1.1-1.4,3.1-4.2,3.1-5.6C14.5,2.3,13.1,0.9,11.3,0.9z"/>
	<path d="M11.3,5.9c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8C13.2,5,12.4,5.9,11.3,5.9z M11.3,3.1
		c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9S11.8,3.1,11.3,3.1z"/>
	<path d="M20.3,16.8c-0.1,0-0.3-0.1-0.4-0.2c-0.3-0.4-3.4-4.1-3.4-6c0-2.1,1.7-3.7,3.7-3.7S24,8.6,24,10.6c0,1.9-3,5.6-3.4,6
		C20.5,16.7,20.4,16.8,20.3,16.8z M20.3,7.8c-1.5,0-2.8,1.2-2.8,2.8c0,1.2,1.8,3.6,2.8,4.9c1-1.3,2.8-3.8,2.8-4.9
		C23,9.1,21.8,7.8,20.3,7.8z"/>
	<path d="M20.3,12.3c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7C22,11.6,21.2,12.3,20.3,12.3z M20.3,9.9
		c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7C21,10.2,20.7,9.9,20.3,9.9z"/>
	<path d="M17.1,15.6c-0.1,0-0.2,0-0.3-0.1L12,12.2c-0.2-0.1-0.3-0.4-0.1-0.7c0.1-0.2,0.4-0.3,0.7-0.1l4.9,3.3
		c0.2,0.1,0.3,0.4,0.1,0.7C17.4,15.5,17.3,15.6,17.1,15.6z"/>
	<path d="M8.4,23.9c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l9-6.2c0.2-0.1,0.5-0.1,0.7,0.1c0.1,0.2,0.1,0.5-0.1,0.7l-9,6.2
	C8.6,23.9,8.5,23.9,8.4,23.9z"/>
</svg>`;

export const spatialsearchIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M12,11c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S14.2,11,12,11z M12,4c-1.7,0-3,1.4-3,3c0,1.7,1.4,3,3,3s3-1.4,3-3
		C15,5.3,13.7,4,12,4z"/>
	<path d="M12,22c-0.2,0-0.3-0.1-0.4-0.2c-0.3-0.4-6.9-10.6-6.9-14.5C4.7,3.2,8,0,12,0c4.1,0,7.3,3.3,7.3,7.3c0,3.9-6.7,14-6.9,14.5
		C12.3,21.9,12.2,22,12,22z M12,1C8.5,1,5.6,3.9,5.6,7.4c0,3.1,4.9,11,6.4,13.3c1.5-2.3,6.4-10.2,6.4-13.3C18.4,3.8,15.5,1,12,1z"/>
	<path d="M12,24c-0.5,0-12,0-12-2.5c0-1.1,2.3-1.9,6.9-2.3c0.3,0,0.5,0.2,0.5,0.4c0,0.3-0.2,0.5-0.4,0.5c-4.6,0.5-5.9,1.2-6,1.5
		c0.3,0.5,4.2,1.5,11,1.5s10.8-1,11-1.6c-0.1-0.2-1.5-0.9-6.1-1.3c-0.3,0-0.5-0.3-0.4-0.5c0-0.3,0.3-0.5,0.5-0.4
		c4.6,0.4,7,1.2,7,2.3C24,24,12.5,24,12,24z"/>
</svg>`;

export const searchIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M8.5,17C3.8,17,0,13.2,0,8.5S3.9,0,8.5,0S17,3.8,17,8.5S13.2,17,8.5,17z M8.5,1C4.4,1,1.1,4.4,1.1,8.5S4.4,16,8.5,16
		S16,12.6,16,8.5S12.7,1,8.5,1z"/>
	<path d="M23.6,24c-0.1,0-0.3,0-0.4-0.1l-9.3-9.3c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l9.3,9.3c0.2,0.2,0.2,0.5,0,0.7
		C23.8,24,23.7,24,23.6,24z"/>
</svg>`;

export const userIcon = svg`<svg height="24" viewBox="0 0 24 24" width="24">
	<path d="M11.5,23H23c0,0,0-2.1-1-4.1c-0.7-1.5-4-2.5-8-4v-3c0,0,1.5-1,1.5-3c0.5,0,1-2,0-2.5c0-0.3,1.3-2.8,1-4.5
	C16-0.6,9-0.6,8.5,1.4c-3,0-1,4.6-1,5c-1,0.5-0.5,2.5,0,2.5c0,2,1.5,3,1.5,3v3c-4,1.5-7.3,2.5-8,4c-1,2-1,4.1-1,4.1H11.5z"/>
</svg>`;
